import { presenceLabel } from '../../../../lib/presence-labels';

import type { PresenceState } from '../../view-models';
import type React from 'react';

export interface PresenceIndicatorProps {
  presence: PresenceState;
  label?: string;
  awayMinutes?: number;
}

const DOT_COLOR: Record<PresenceState, string> = {
  online: 'var(--success-fg)',
  away: 'var(--warning-fg)',
  busy: 'var(--info-fg)',
  offline: 'var(--fg-4)',
};

/**
 * Bolinha + rótulo de presença nas telas do supervisor.
 *
 * N2-23 (noturna 05/Set/2026): renderizava o enum cru («away», «busy»). O texto vem do
 * domicílio único `lib/presence-labels` — o enum segue só em `data-presence` (CSS/teste).
 */
export function PresenceIndicator({
  presence,
  label,
  awayMinutes,
}: PresenceIndicatorProps): React.JSX.Element {
  const base = presenceLabel(presence);
  const text =
    presence === 'away' && awayMinutes !== undefined && awayMinutes > 0
      ? `${base} há ${String(awayMinutes)}min`
      : base;
  return (
    <span className="presence-ind" data-presence={presence}>
      <span
        className="presence-ind__dot"
        style={{ background: DOT_COLOR[presence] ?? DOT_COLOR.offline }}
        aria-hidden="true"
      />
      <span className="presence-ind__label">{label ?? text}</span>
    </span>
  );
}
